import React, { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';
import { CSS } from '@dnd-kit/utilities';
import { AnimateLayoutChanges, defaultAnimateLayoutChanges, useSortable } from '@dnd-kit/sortable';

import Icon, { IconmoonFont } from 'vibo-ui/Icon';

import { useSelectList } from 'components/context/SelectListContext';

import useStyles from './style';

const animateLayoutChanges: AnimateLayoutChanges = args => {
  if (args.isSorting || args.wasDragging) {
    return false;
  }
  return defaultAnimateLayoutChanges(args);
};

interface DraggableProps extends WithId {
  dragByHandler?: boolean;
  disabled?: boolean;
}

const Draggable: FC<PropsWithChildren<DraggableProps>> = ({
  dragByHandler = false,
  disabled = false,
  _id,
  children,
}) => {
  const classes = useStyles();

  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({
    id: _id,
    disabled,
    animateLayoutChanges,
  });

  const selectedIdsContext = useSelectList();

  const styles = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging
      ? 0
      : isDragging && selectedIdsContext?.selectedIds.includes(_id)
      ? '0.2'
      : 1,
  };

  return (
    <div
      className={classNames('draggable', classes.draggable, {
        isDragging,
        dragByHandler,
        disabled,
      })}
      ref={setNodeRef}
      style={styles}
      {...attributes}
      {...listeners}
    >
      {dragByHandler && !disabled ? (
        <Icon icon={IconmoonFont['dnd-16']} className="dndIcon" />
      ) : null}
      {children}
    </div>
  );
};

export default Draggable;
